import React from 'react'
import { animated } from 'react-spring'

import { useQuizContext } from 'store/QuizStore'
import { FluidBox } from 'styled/index.js'
import {
  Root,
  WelcomeBox,
  EnterButton,
  AnimationBox,
  Heading,
  CloseButton,
} from './WelcomeModal.styled.js'
import { ReactComponent as CloseIcon } from './../../assets/close-icon.svg'
import animation from './../../assets/welcome-animation.mp4'

const WelcomeModal = ({ style }) => {
  const { dispatch } = useQuizContext()

  const hideModal = () => {
    dispatch({ type: 'SHOW_WELCOME', show: false })
  }

  return (
    <Root style={style}>
      <WelcomeBox p="spaceLarge">
        <Heading mb="spaceLarge">
          <FluidBox fs="textMedium" color="primary" pr="spaceNormal">
            Welcome to the interactive quiz
          </FluidBox>
          <CloseButton onClick={hideModal}>
            <CloseIcon></CloseIcon>
          </CloseButton>
        </Heading>
        <AnimationBox>
          <div className="Inner">
            <video src={animation} muted autoPlay loop playsInline></video>
          </div>
        </AnimationBox>
        <FluidBox my="spaceLarge" lh={1.25}>
          Navigate through the questions on the bottom bar after selecting your answer. Responses
          are saved and submitted when you click Next on each page.
        </FluidBox>
        <EnterButton onClick={hideModal}>Continue</EnterButton>
      </WelcomeBox>
    </Root>
  )
}

export default animated(WelcomeModal)
